module.exports = __webpack_public_path__ + "static/5-1bae37b5140aced7d544f00373d830e3.png";